module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('div', {
    staticClass: "head-nav"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "head-option"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.token == ''),
      expression: "token == ''"
    }],
    staticClass: "nav-right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "link_us"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goAnchor('last')
      }
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.token != ''),
      expression: "token != ''"
    }],
    staticClass: "nav-myinfo clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "link_us"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goAnchor('last')
      }
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "out"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("退出")])])]), _vm._v(" "), _c('div', {
    staticClass: "category clearfix"
  }, [_c('ul', {
    staticClass: "category-wrap clearfix"
  }, _vm._l((_vm.menus), function(menuItem, index) {
    return _c('li', {
      key: index,
      staticClass: "menu-item",
      on: {
        "click": function($event) {
          return _vm.toMenu(menuItem.path, index)
        }
      }
    }, [_c('router-link', {
      key: index,
      staticClass: "tab-item",
      attrs: {
        "to": menuItem.path
      }
    }, [_vm._v(_vm._s(menuItem.name))])], 1)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-area middle-content"
  }, [(_vm.isRouterAlive) ? _c('router-view', {
    on: {
      "token": _vm.changeToken
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "huojian yincang"
  }, [_vm._v("UP")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-logo"
  }, [_c('div', {
    staticClass: "site-logo"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/img/home-2025-school-logo.png"),
      "alt": "东大建筑新人赛"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link_us"
  }, [_c('a', {
    attrs: {
      "href": "#/post"
    }
  }, [_vm._v("上传作品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal_info"
  }, [_c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('span', {
    staticClass: "small_line"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/regist"
    }
  }, [_vm._v("注册")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link_us"
  }, [_c('a', {
    attrs: {
      "href": "#/post"
    }
  }, [_vm._v("上传作品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutme"
  }, [_c('div', [_vm._v("我的")]), _vm._v(" "), _c('ul', {
    staticClass: "zh_myinfo"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "color": "#182345"
    },
    attrs: {
      "href": "#/work"
    }
  }, [_vm._v("我的作品")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "color": "#182345"
    },
    attrs: {
      "href": "#/user"
    }
  }, [_vm._v("资料与账号")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    attrs: {
      "id": "last"
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "link_div"
  }, [_vm._v("主办单位: 东南大学建筑学院")]), _vm._v(" "), _c('div', {
    staticClass: "link_div"
  }, [_vm._v("官方邮箱: arch_newer@foxmail.com")]), _vm._v(" "), _c('div', {
    staticClass: "link_div",
    staticStyle: {
      "margin-top": "40px",
      "font-size": "12px"
    }
  }, [_vm._v("南京清晓信息科技有限公司 © 2025 "), _c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("苏ICP备13063229号-4")])]), _vm._v(" "), _c('div', {
    staticClass: "ball_wrap"
  }, [_c('div', {
    staticClass: "ball ball_wx"
  }, [_c('div', {
    staticClass: "erweima erweima_status"
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "font-family": "sy",
      "font-size": "12px",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f9d1ac0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 615
// module chunks = 1